import './index.css';
import styled, { createGlobalStyle } from "styled-components";
import { LOGO } from "@assets";

const GlobalStyles = createGlobalStyle`
* {
  margin: 0;
  font-family: 'Prompt', 'Myanmar Census';
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000000;
}

#root {
  width: 100vw;
  overflow-x: hidden;
  max-width: 480px;
  height: 100vh;
  background: ${(props) => props.theme.backgroundColor};   
}

input {
  background-color: #242424 !important;
  /* border-color: none !important; */
  color: #FFFFFF !important;
  font-size: 20px;
  font-weight: 400;
  line-height: 26.86px;
}

input::placeholder {
  color: #7E8485 !important;
  font-weight: 400;
  font-size: 16px;
}

.ant-spin-dot i {
  background-color: ${(props) => props.theme.primaryColor} !important;
}

.ant-modal:not(.custom-calendar-modal):not(.lang-modal):not(.pocket-money-modal) {
    
  .ant-modal-content {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 18px;
    border-radius: 16px;
    background: #49028E;
  }

  .ant-modal-body {
    padding: 0px 6px;
    color: #FFFFFF !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: normal !important;
  }

  .ant-modal-header {
    background: transparent !important;
    margin: 0;
  }

  .ant-modal-title {
    background-color: transparent !important;
    color: #FFFFFF !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: normal !important;
  }

  .ant-modal-footer {
    margin: 0;
    display: flex;
    justify-content: center;
    background-color: #340067;
    border-radius: 0 0 16px 16px;

    .ant-btn {
      flex: 1;
      width: 100%;
      padding: 0 !important;
      margin: 0 !important;
      height: 60px !important;
      border-radius: 0 !important;
      background-color: transparent !important;
      box-shadow: none !important;
      font-size: 16px;
      font-weight: 500;
      color: #fff !important;

      :first-child {
        border-right: 1px solid #5D5189 !important;
      }
    }
  }
}

.ant-btn-primary:not(.ant-btn-dangerous) {
  background: ${(props) => props.theme.buttonColor};
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px;
  border-radius: 12px;
  width: 100%;
  border: none !important;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  color: #fff !important;

  :hover {
    background: ${(props) => props.theme.buttonHoverColor};
    border: none !important;
  }

  :disabled {
    color: #5D5189 !important;

    :hover {
      background: ${(props) => props.theme.buttonColor};
    }
  }
}

.ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover{
  background: ${(props) => props.theme.buttonHoverColor};
}

.ant-btn-default {
background-color: #212224 !important;
color: #F9F9F9 !important;
border: none !important;
border-radius: 12px;

font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: 1.5;

  :hover {
    background-color: #212224 !important;
    color: #F9F9F9 !important;
    border: none !important;
  }
}

.ant-table-wrapper {
  
  tr:nth-child(2n) {
    td {
      background-color: #E1CCE0;
    }

    :hover {
      td {
        background-color: #E1CCE0 !important;
      }
    }
  }

  tr {
      >td {
        background-color: ${(props) => props.theme.backgroundColor};

        font-size: 14px;
        font-weight: normal;
        color: #000000;

        :first-child, :last-child {
          padding: 8px 24px !important;
        }
    }

    :hover {
      >td {
        background-color: ${(props) => props.theme.backgroundColor} !important;
      }
    }
  }

  tr>th {
    background-color: #71207C !important;
    font-size: 14px !important;
    font-weight: normal !important;
    color: #FFFFFF !important;

    ::before {
      display: none;
    }

    :first-child {
      border-start-start-radius: 5px !important;
      border-end-start-radius: 5px !important;
      padding: 8px 24px !important;
    }

    :last-child {
      border-start-end-radius: 5px !important;
      border-end-end-radius: 5px !important;
      padding: 8px 24px !important;
    }
  }
}

.ant-radio-wrapper .ant-radio-checked {
    
  ::after {
    border: 1px solid ${(props) => props.theme.primaryColor};
  }

  .ant-radio-inner {
    border-color: ${(props) => props.theme.primaryColor};
    background-color: ${(props) => props.theme.primaryColor};
  }
}

.ant-picker-calendar {
    .ant-radio-group {
        display: none !important;
    }
}

.ant-notification-notice {
  padding: 12px !important;
}

.ant-notification-notice-close {
  top: 12px !important;
}

.ant-notification-notice-description {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
-ms-overflow-style: none;  /* IE and Edge */
scrollbar-width: none;  /* Firefox */

.otp-length-8 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 5px;

  @media screen and (max-width: 290px) {
    flex-wrap: wrap;
  }
}

.otp-length-6 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 2px;

  @media screen and (max-width: 290px) {
    flex-wrap: wrap;
    justify-content: center;
  }
}

.custom-calendar-modal {

  .ant-modal-footer {
      text-align: center;
  }

  @media screen and (max-width: 325px) {
    .ant-modal-content {
      padding: 20px 0 !important;
    }
  }
  
}

.trx-history-dropdown {
  background-color: #EFEFEF;

  .ant-select-item-option {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: #101415;
  }
}

.ant-drawer-content-wrapper {
    height: auto !important;
}

.ant-form-item-explain-error {
  font-size: 12px;
}

.ant-result {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .ant-result-title {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
    color: ${props => props.theme.primaryColor};
  }

  .ant-result-subtitle {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #5D5189;
  }

  .ant-btn-primary {
    min-width: 170px;
    height: 52px;

    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
    color: #ffffff !important;
  }
}

input {
    font-family: Prompt !important;
    font-size: 16px;
    font-weight: 400;

    ::placeholder {
      font-family: Prompt !important;
      color: #9B92BB !important;
    }
}

.ant-input:focus::placeholder {
    color: transparent !important;
  }

.grecaptcha-badge { visibility: hidden; }
`;

export const Logo = styled.img.attrs({
  alt: "logo-img",
  src: LOGO,
})``;

export default GlobalStyles;
